import React, { useEffect, useState } from 'react'
import './Profile.css'
import axios from 'axios'
import DisplayOrder from './DisplayOrder'
import './Profile.css'
import { useAuthContext } from '../hooks/useAuthContext'

const Profile = () => {
    const [orders, setOrders] = useState([])
    const {user} = useAuthContext()
    const [error, setError] = useState(null)

    useEffect(() => {
        if(!user) {
            // setError('Login / SignUp please')
            return
          }
        const fetch = async () => {
            const url = 'https://myrestaurantmz3699-junaidedmehroz3699.b4a.run/getOrders';
            // const res = await fetch(url, {
            //     headers : { 
            //         'Authorization' : `Bearer ${user.token}`
            //     }
            // })
            // const myOrders = await res.json()
            const res = await axios.get(url, { headers : { 
                'Authorization' : `Bearer ${user.token}`
            }})
            const myOrders = res.data;
            // console.log(myOrders);
            const myOrders2 = myOrders.map(myOrder => Object.entries(myOrder.order))
            // console.log(myOrders2);
            const myOrders3 = myOrders2.map(myOrder2 => {
                const myOrders4 = myOrder2.filter(x => {
                    if(x[1][0] > 0) return x
                })
                return myOrders4
            })
            // console.log(myOrders3);
            setOrders(myOrders3)
        }
        fetch()
    },[])

  return (
    <div>
        <h2 className='heading'>My Orders</h2>
        {error && <p>{error}</p> }
        <div className="orders">
            {orders.map(order => <DisplayOrder order={order} key={order} />)}
        </div>
    </div>
  )
}

export default Profile